module.exports = __webpack_public_path__ + "img/laundry.09cd4e55.svg";